import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { loanService } from '../../services/loanService';

export const useGetLenderLoanDetail = fundraisingId => {
  return useQuery({
    queryKey: [QUERY_KEYS.loan.lender_loan_detail, fundraisingId],
    queryFn: () =>
      loanService.lenderLoanDetail(fundraisingId).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};